import { Card } from 'antd'

export default props => (
  <Card
    title='下载APP'
  >
    <div className='qrcode'>
      {/* <img src='https://duckfiles.oss-cn-qingdao.aliyuncs.com/eleduck/assets/qrcode.png' alt="二维码" /> */}
      <img src='https://duckfiles.oss-cn-qingdao.aliyuncs.com/eleduck/assets/app.png' alt="二维码" />
      <p>扫码下载，远程工作不会错过鸭：）</p>
    </div>

    <style jsx>{`
      .qrcode {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
      }

      .qrcode img {
        width: 128px;
        height: 128px;
        margin-bottom: 15px;
      }

      .qrcode p {
        margin: 0 0 5px 0;
        padding: 0;
        font-size: 13px;
        color: #7B7B7B;
      }
    `}
    </style>
  </Card>
)
